import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "sprout-ui-dom";
import { Text } from "sprout-ui-primitives";
import styled from "styled-components";
import { media } from "sprout-ui-theme";
const ArchiveTodoButton = styled(Button)`
  color: inherit;

  ${media.target("pointer")} {
    &:hover {
      text-decoration: underline;
    }
  }
`;
const PostPageTodoListRatio = (props)=>{
    const { disabled , pressToEdit , completedCount , totalCount , onArchive  } = props;
    return /*#__PURE__*/ _jsxs(Text, {
        color: "black.60",
        fontSize: pressToEdit ? 2 : 1,
        fontWeight: "regular",
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: `${completedCount}/${totalCount} completed`
            }),
            completedCount === totalCount && !disabled && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    ` - `,
                    /*#__PURE__*/ _jsx(ArchiveTodoButton, {
                        onClick: onArchive,
                        children: "Archive list"
                    })
                ]
            })
        ]
    });
};
export default PostPageTodoListRatio;
